export default __webpack_public_path__ + "static/media/ResearchGate.d6419cbf.png";